import { render, staticRenderFns } from "./AssessmentGroupCheckboxPanel.vue?vue&type=template&id=292f2061&scoped=true"
import script from "./AssessmentGroupCheckboxPanel.vue?vue&type=script&lang=js"
export * from "./AssessmentGroupCheckboxPanel.vue?vue&type=script&lang=js"
import style0 from "./AssessmentGroupCheckboxPanel.vue?vue&type=style&index=0&id=292f2061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f2061",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
